import { ConfirmationDialog, useDialog } from '@axellero/shared';
import type { ReactElement } from 'react';
import { useCallback, useState } from 'react';
import { useMutation } from 'urql';

import { mutationRemoveVariable } from '../model/mutationRemoveVariable.gql';
import type {
  RemoveVariableMutation,
  RemoveVariableMutationVariables,
} from '../model/mutationRemoveVariable.gql.gen';

export const useRemoveVariable = (): [element: ReactElement, start: (id: string) => void] => {
  const [{ fetching }, removeVariable] = useMutation<
    RemoveVariableMutation,
    RemoveVariableMutationVariables
  >(mutationRemoveVariable);

  const [dialogProps, setDialogOpen] = useDialog();

  const [variableId, setVariableId] = useState('');

  const resetForm = useCallback(() => {
    setVariableId('');
  }, []);

  const handleStart = useCallback(
    (id: string) => {
      resetForm();
      setVariableId(id);
      setDialogOpen(true);
    },
    [resetForm, setDialogOpen]
  );
  const handleReset = useCallback(() => {
    resetForm();
    setDialogOpen(false);
  }, [resetForm, setDialogOpen]);
  const handleSubmit = useCallback(() => {
    removeVariable({ id: variableId }).then(() => {
      setDialogOpen(false);
    });
  }, [removeVariable, setDialogOpen, variableId]);

  /* eslint-disable jsx-a11y/no-autofocus */
  return [
    <ConfirmationDialog
      key="remove-variable"
      title="Remove Variable"
      {...dialogProps}
      loading={fetching}
      onReset={handleReset}
      onSubmit={handleSubmit}
    />,
    handleStart,
  ];
  /* eslint-enable jsx-a11y/no-autofocus */
};
